import { getWeek } from 'date-fns';
import { useAllocationsContext } from './allocations-context';
import AllocationsPersonal from './allocations-personal';
import PageLoader from 'components/loaders/page-loader';
import useAllocationsData from 'core/api/hooks/allocations/use-allocations-data';

function AllocationsPersonalContainer() {
    const { week, year } = useAllocationsContext();
    // const y = getYear(new Date());
    const dateParam = `${year}-${week ? week : getWeek(new Date())}`;

    const {
        data: allocations,
        isFetching,
        isLoading
    } = useAllocationsData({
        week: dateParam
    });

    return isFetching || isLoading ? (
        <div className="flex items-center justify-center h-full">
            <PageLoader
                suppressBackground={true}
                type="fast"
                text={'Loading allocations...'}
            ></PageLoader>
        </div>
    ) : (
        <AllocationsPersonal
            allocations={allocations}
            isFetching={isFetching}
            isLoading={isLoading}
            refetch
        ></AllocationsPersonal>
    );
}

export default AllocationsPersonalContainer;
